import { useState } from 'react';

export const useBrowserLocale = () => {
  // @ts-ignore
  const [state] = useState(navigator.language || navigator.userLanguage);
  return state;
};
